module.exports = require("app");


/*****************
 ** WEBPACK FOOTER
 ** external "app"
 ** module id = 17
 ** module chunks = 0
 **/